/**
 * Lifecycle status of a competition.
 *
 * The effective status is normally derived from the configured timestamps, but
 * an administrator can pin it. `competitions.status_override` holds the pinned
 * value and `competitions.status` holds the last computed value, so a later
 * recomputation cannot silently discard an administrator's decision.
 */
export const COMPETITION_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  REGISTRATION_OPEN: 'registration_open',
  SUBMISSION_OPEN: 'submission_open',
  JUDGING: 'judging',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
} as const

export type CompetitionStatus = (typeof COMPETITION_STATUSES)[keyof typeof COMPETITION_STATUSES]

export const COMPETITION_STATUS_VALUES = Object.values(COMPETITION_STATUSES) as [
  CompetitionStatus,
  ...CompetitionStatus[],
]

/** All timestamps are stored in UTC; this only affects presentation. */
export const DEFAULT_COMPETITION_TIMEZONE = 'Asia/Taipei'
export const DEFAULT_COMPETITION_LOCALE = 'zh-TW'
